(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("classnames"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "classnames", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["ReactContexify"] = factory(require("react"), require("prop-types"), require("classnames"), require("react-dom"));
	else
		root["ReactContexify"] = factory(root["react"], root["prop-types"], root["classnames"], root["react-dom"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_14__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition